// ─── buildPublicationMarkers.js ─────────────────────────────────────────
// Refonte écran Suivi — Phase 4 (socle). Voir docs/PLAN-REFONTE-ECRAN-SUIVI.md.
//
// Fonction PURE : produit les marqueurs « statut de publication » à ajouter sur
// la frise (SuiviCockpitTimeline) — la version en attente de validation et la
// publication programmée. Consomme la donnée déjà récupérée (brouillon en
// attente, statut clients-status). Ne fetch/positionne rien : renvoie des
// descripteurs { kind, date, label }, la frise les place via pctOnTimeline.
//
// LIMITE ASSUMÉE : le statut « publié/visible » PAR VERSION n'est PAS calculé
// ici — le numéro de version publiée n'est pas exposé côté SaaS (cf.
// republicationNotice). Le taguer demandera d'abord d'exposer cette donnée.
// Ce module couvre les deux signaux « anti-surprise » réalisables aujourd'hui.

import { describeRepublication } from './republicationNotice';

/**
 * Marqueurs de publication pour la frise.
 *
 * @param {object} [opts]
 * @param {object|null} [opts.pendingDraft] - brouillon en attente { created_at }
 * @param {object|null} [opts.statusEntry] - entrée clients-status
 * @param {Date} [opts.now]
 * @returns {Array<{ kind:'pending'|'scheduled', date:string, label:string }>}
 */
export function buildPublicationMarkers(opts = {}) {
  const { pendingDraft = null, statusEntry = null, now = new Date() } = opts;
  const markers = [];

  if (pendingDraft && pendingDraft.created_at) {
    markers.push({
      kind: 'pending',
      date: pendingDraft.created_at,
      label: 'Version en attente de validation',
    });
  }

  const repub = describeRepublication(statusEntry, now);
  if (repub && repub.variant === 'scheduled' && repub.dateISO) {
    markers.push({
      kind: 'scheduled',
      date: repub.dateISO,
      label: 'Publication programmée',
    });
  }

  return markers;
}
